var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragFlatGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10.25C6.24632 10.25 6.75 9.74632 6.75 9.125C6.75 8.50368 6.24632 8 5.625 8C5.00368 8 4.5 8.50368 4.5 9.125C4.5 9.74632 5.00368 10.25 5.625 10.25Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.25C12.6213 10.25 13.125 9.74632 13.125 9.125C13.125 8.50368 12.6213 8 12 8C11.3787 8 10.875 8.50368 10.875 9.125C10.875 9.74632 11.3787 10.25 12 10.25Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.25C18.9963 10.25 19.5 9.74632 19.5 9.125C19.5 8.50368 18.9963 8 18.375 8C17.7537 8 17.25 8.50368 17.25 9.125C17.25 9.74632 17.7537 10.25 18.375 10.25Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 17C6.24632 17 6.75 16.4963 6.75 15.875C6.75 15.2537 6.24632 14.75 5.625 14.75C5.00368 14.75 4.5 15.2537 4.5 15.875C4.5 16.4963 5.00368 17 5.625 17Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17C12.6213 17 13.125 16.4963 13.125 15.875C13.125 15.2537 12.6213 14.75 12 14.75C11.3787 14.75 10.875 15.2537 10.875 15.875C10.875 16.4963 11.3787 17 12 17Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 17C18.9963 17 19.5 16.4963 19.5 15.875C19.5 15.2537 18.9963 14.75 18.375 14.75C17.7537 14.75 17.25 15.2537 17.25 15.875C17.25 16.4963 17.7537 17 18.375 17Z",
    fill: "#4D4D4D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragFlatGrey);
export default __webpack_public_path__ + "static/media/drag_flat_grey.aa8362e1d369389d03c893266c1ede06.svg";
export { ForwardRef as ReactComponent };